import { MenuItem, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import type { ChangeEvent } from "react";
import { UtilityTarget } from "../models/UtilityTarget";
import { getUtilityTargets } from "../repositories/UtilityTargetRepository";

export const useUtilityTargets = () =>
	useQuery<UtilityTarget[], Error>({
		queryKey: ["utility-targets"],
		queryFn: ({ signal }) => getUtilityTargets(signal),
		staleTime: Number.POSITIVE_INFINITY,
		retry: 1,
	});

interface UtilityTargetSelectorProps {
	targetId: number | null;
	onTargetChange: (targetId: number | null) => void;
}

export const UtilityTargetSelector = ({
	targetId,
	onTargetChange,
}: UtilityTargetSelectorProps) => {
	const { data: targets, isLoading } = useUtilityTargets();

	const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
		onTargetChange(Number(event.target.value));

	return (
		<TextField
			select
			label="Area"
			size="small"
			fullWidth
			disabled={isLoading}
			value={targetId ?? ""}
			onChange={handleChange}
		>
			{(targets ?? []).map((target) => (
				<MenuItem key={target.TargetId} value={target.TargetId}>
					{target.TargetName}
				</MenuItem>
			))}
		</TextField>
	);
};
